import { render, staticRenderFns } from "./AccountAddToCohort.vue?vue&type=template&id=33eb80ae&"
import script from "./AccountAddToCohort.vue?vue&type=script&lang=js&"
export * from "./AccountAddToCohort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports